import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaBorderRadius, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

export const TacticCardWrapperStyle: SxProps<Theme> = {
  padding: YodaSpacing.medium,
  boxShadow: `0px 5px 20px ${YodaColors.gray2}`,
  borderRadius: YodaBorderRadius.medium,
};

export const printViewLayout: SxProps<Theme> = {
  margin: YodaSpacing.small,
  width: '100vw',
};

export const TitlePrintStyle: SxProps<Theme> = {
  textAlign: 'center',

  '& .titlePrintView': {
    marginBottom: YodaSpacing.xSmall,
    fontSize: YodaFontSize.xxxLarge,
    fontWeight: YodaFontWeight.medium,
  },

  '& .datePrintView': {
    marginBottom: YodaSpacing.large,
    fontSize: YodaFontSize.xxLarge,
    fontWeight: YodaFontWeight.light,
  },
};

export const PrintWrapperStyle: SxProps<Theme> = {
  width: '100%',
};

export const TacticPrintViewStyle: SxProps<Theme> = {
  marginTop: YodaSpacing.medium,
  paddingBottom: YodaSpacing.medium,
  display: 'flex',
  flexDirection: 'column',
  gap: YodaSpacing.small,

  '& > *': {
    minWidth: '260px',
  },
};

export const TacticCardListStyle: SxProps<Theme> = {
  '& > *': {
    border: `1px solid ${YodaColors.gray7} !important`,
    borderRadius: YodaBorderRadius.small,
    marginBottom: YodaSpacing.small,
  },
  '& > *:last-child': {
    marginBottom: 0,
  },
  '& > *:hover': {
    backgroundColor: YodaColors.blue1,
    boxShadow: `0 0 7px 1px ${YodaColors.gray2}`,
  },
};

